import { Component, OnInit } from '@angular/core';
import { EnquiryComponent } from '../enquiry/enquiry.component';
import { MatBottomSheet} from '@angular/material/bottom-sheet';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DataService } from '../services/data.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LocationMappingService } from '../services/location-mapping.service';


interface Branch {
  embeddedLink: string;
  location: string;
  email: string;
  mobile: string;
  address: string;
}

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent implements OnInit {

  public branchList=[]
  public selectedBranch: string = '';
  public filteredContact: Branch = {
    embeddedLink: '',
    location: '',
    email: '',
    mobile: '',
    address: ''
  }
  public headOffice: Branch = {
    embeddedLink: '',
    location: '',
    email: '',
    mobile: '',
    address: ''
  }
  safeEmbeddedLink: SafeHtml;

  constructor(
    private bottomSheet: MatBottomSheet,
    private dataService: DataService,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
    private route: ActivatedRoute,
    private locationMappingService: LocationMappingService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Contact NICT Computer Education | Multiple Branches in Bangalore');
  this.metaService.updateTag({
    name: 'description',
    content: 'Get in touch with NICT Computer Education. Find addresses, phone numbers, and email for all our computer training branches in Bangalore including Jayanagar, Hanumathnagar, Domlur, Channasandra, Malleshwaram, Rajajinagar, and more.'
  });

  // Optional: Social sharing (Open Graph)
  this.metaService.updateTag({ property: 'og:title', content: 'Contact NICT Computer Education' });
  this.metaService.updateTag({ property: 'og:description', content: 'Contact NICT branches across Bangalore. Get directions, email, phone numbers and more.' });
  this.metaService.updateTag({ property: 'og:url', content: 'https://www.nictcomputereducation.com/contact' });
  this.metaService.updateTag({ property: 'og:image', content: 'https://www.nictcomputereducation.com/assets/logo.ico' });
    this.dataService.getBranches().subscribe(res => {
      this.branchList=res;
      
      // Check for location parameter in route
      const locationParam = this.route.snapshot.paramMap.get('location');
      let targetLocation: string | null = null;
      
      if (locationParam) {
        // Store the slug and get location
        targetLocation = this.locationMappingService.getLocationAndStore(locationParam);
      } else {
        // If no location in URL, check localStorage
        targetLocation = this.locationMappingService.getStoredLocation();
      }
      
      if (targetLocation) {
        // Find and select the branch matching the location
        const matchingBranch = this.branchList.find(branch => 
          branch.location.toLowerCase() === targetLocation.toLowerCase()
        );
        
        if (matchingBranch) {
          this.selectedBranch = matchingBranch.location;
        } else if (this.branchList.length > 0) {
          this.selectedBranch = this.branchList[0].location;
        }
      } else if (this.branchList.length > 0) {
        this.selectedBranch = this.branchList[0].location; 
      }
      
      this.onBranchChange();
    })
  }

  onBranchChange() {
    // Find the selected branch from the list
    const selected = this.branchList.find(branch => branch.location === this.selectedBranch);
    const head = this.branchList.find(branch => branch.location === "Jayanagar");
    if (selected) {
      this.filteredContact = selected;
      this.headOffice = head;

      // Now update the safeEmbeddedLink after branch is selected
      this.safeEmbeddedLink = this.sanitizer.bypassSecurityTrustHtml(this.filteredContact.embeddedLink);
    }
  }

  openBottomSheet(): void {
    // Pass location to enquiry form if branch is selected
    this.bottomSheet.open(EnquiryComponent,{
      data:{
        source : "contact page",
        location: this.selectedBranch || null
      }
    });
  }

}
